
import { useMediaQuery } from 'usehooks-ts';

import type { MembershipTierId } from '@api';

import Avatar from '@store:web/components/common/Avatar/Avatar';
import { Karma } from '@ui/uikit/components/icons/mono/Karma';
import { formatAmountCompact } from '@ui/uikit/utils';

type Props = {
  name?: string;
  membershipTierId?: MembershipTierId;
  src?: string;
  karma?: number;
};

export const UserCard = ({ name, membershipTierId, src, karma }: Props) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Avatar
      userInfo={{
        displayName: name,
        membership: membershipTierId
          ? {
              tier: membershipTierId,
            }
          : undefined,
      }}
      src={src}
      sizeInPX={isMobile ? 24 : 32}
      containerClassName="flex flex-row gap-2 items-center "
    >
      <div
        title={name || 'noname'}
        className="text-caption-sm-strong-a max-w-full overflow-hidden whitespace-nowrap text-ellipsis"
      >
        {name || 'noname'}
      </div>
      {!!karma && (
        <span className="flex items-center gap-0.5">
          <Karma className="text-base-text-pink size-4" />

          <span className="text-caption-sm-a">{formatAmountCompact(karma)}</span>
        </span>
      )}
    </Avatar>
  );
};
